import { useLang } from 'hooks/lang';

import { Collapse, LabeledInput, Column, LabeledSelect } from 'components/Blocks';

import { OtherAdvise } from './OtherAdvise';

import { sortByProperty } from 'utils/array';
import { omitUndefined } from 'utils/object';
import { OTHER, actions } from '../utils';
import { OTHER_CHAR_LIMIT } from './utils';

import { StateProps } from './types';

export function Actions({ state, dispatch }: StateProps) {
  const { t } = useLang();

  const otherAction = state.actions.find(({ action }) => action === OTHER);

  return (
    <Column>
      <LabeledSelect
        id="actions"
        label={t('actions-taken') as string}
        isMulti
        onChangeDirect={(actions) =>
          dispatch({
            actions: actions.map((action) =>
              omitUndefined({
                action,
                other: action === OTHER ? otherAction?.other ?? '' : undefined,
              }),
            ),
          })
        }
        value={state.actions.map(({ action }) => action)}
        options={sortByProperty(
          actions.map(({ id, getLabel }) => ({ id, label: getLabel(t) })),
          'label',
        )}
      />

      <Collapse expanded={!!otherAction} onlyRenderIfExpanded>
        <Column>
          <LabeledInput
            name="other"
            label={t('other-actions')}
            value={otherAction?.other ?? ''}
            onChange={({ target }) =>
              dispatch({
                actions: state.actions.map(({ action }) =>
                  action === OTHER
                    ? { action, other: target.value.slice(0, OTHER_CHAR_LIMIT) }
                    : { action },
                ),
              })
            }
          />

          {!!otherAction?.other && <OtherAdvise other={otherAction?.other} />}
        </Column>
      </Collapse>
    </Column>
  );
}

export default Actions;
